// A1 - Ünite 4: Can / Could (Yetenek ve Rica)
// Hedef: Yapabilmek, izin almak, nazik istekler

export const A1_UNIT_4 = {
  'A1-U4-L1': {
    id: 'A1-U4-L1',
    title: 'Can + fiil (yetenek)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Can - Yapabilmek',
          explanation: '"Can" bir şeyi yapabilme yeteneğini ifade eder. Tüm öznelerle aynı şekilde kullanılır ve fiil kök haliyle gelir.',
          table: {
            headers: ['Özne', 'Can', 'Fiil', 'Örnek'],
            rows: [
              ['I', 'can', 'speak', 'I can speak English.'],
              ['You', 'can', 'swim', 'You can swim.'],
              ['He/She', 'can', 'fly', 'She can fly.'],
              ['We', 'can', 'help', 'We can help you.'],
              ['They', 'can', 'work', 'They can work hard.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Kabin Ekibi Yetenekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['I can speak three languages.', 'Üç dil konuşabilirim.'],
              ['I can handle difficult situations.', 'Zor durumların üstesinden gelebilirim.'],
              ['I can work under pressure.', 'Baskı altında çalışabilirim.'],
              ['I can provide excellent service.', 'Mükemmel hizmet sunabilirim.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta yeteneklerinizi anlatırken "I can..." ile başlayın!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Yetenek Kelimeleri',
          words: [
            { en: 'ability', tr: 'yetenek', pronunciation: '/əˈbɪləti/' },
            { en: 'skill', tr: 'beceri', pronunciation: '/skɪl/' },
            { en: 'handle', tr: 'üstesinden gelmek', pronunciation: '/ˈhændl/' },
            { en: 'manage', tr: 'yönetmek', pronunciation: '/ˈmænɪdʒ/' },
            { en: 'communicate', tr: 'iletişim kurmak', pronunciation: '/kəˈmjuːnɪkeɪt/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ speak English fluently.',
          options: ['can', 'cans', 'could', 'am can'],
          correct: 'can',
          explanation: 'Can tüm öznelerle aynı şekilde kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: 'She _____ handle difficult passengers.',
          answer: 'can',
          hint: 'Yetenek ifade ediyor'
        },
        {
          type: 'matching',
          instruction: 'Yetenekleri eşleştirin',
          pairs: [
            { left: 'I can speak', right: 'languages' },
            { left: 'I can work', right: 'under pressure' },
            { left: 'I can provide', right: 'excellent service' }
          ]
        }
      ]
    }
  },
  'A1-U4-L2': {
    id: 'A1-U4-L2',
    title: "Can't + fiil (olumsuz)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Can\'t - Yapamamak',
          explanation: '"Can\'t" (cannot) bir şeyi yapamadığımızı ifade eder.',
          table: {
            headers: ['Olumlu', 'Olumsuz', 'Türkçesi'],
            rows: [
              ['I can swim', "I can't swim", 'Yüzebilirim / Yüzemem'],
              ['She can fly', "She can't fly", 'Uçabilir / Uçamaz'],
              ['We can help', "We can't help", 'Yardım edebiliriz / Edemeyiz']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçuşta Kısıtlamalar',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Durum'],
            rows: [
              ["You can't smoke on the plane.", 'Uçakta sigara içemezsiniz.', 'Yasak'],
              ["You can't use electronic devices.", 'Elektronik cihaz kullanamazsınız.', 'Kalkış/iniş'],
              ["We can't serve alcohol now.", 'Şimdi alkol servis edemiyoruz.', 'Kural'],
              ["I can't help you right now.", 'Şu an yardım edemiyorum.', 'Meşgul']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "cannot" bir kelime olarak yazılır. Konuşmada genelde "can\'t" tercih edilir.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "You _____ smoke on the aircraft.",
          options: ["can't", 'can', 'could', "couldn't"],
          correct: "can't",
          explanation: 'Sigara içmek yasak - can\'t'
        },
        {
          type: 'fillInBlank',
          sentence: "I _____ speak Chinese, but I can speak Japanese.",
          answer: "can't",
          hint: "Yapamama durumu"
        },
        {
          type: 'matching',
          instruction: 'Kuralları eşleştirin',
          pairs: [
            { left: "You can't smoke", right: 'on the plane' },
            { left: "We can't serve alcohol", right: 'during takeoff' },
            { left: "Passengers can't stand", right: 'when seatbelt sign is on' }
          ]
        }
      ]
    }
  },
  'A1-U4-L3': {
    id: 'A1-U4-L3',
    title: 'Can I...? Can you...? (izin/rica)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Can ile İzin ve Rica',
          explanation: '"Can I...?" izin istemek, "Can you...?" birinden bir şey rica etmek için kullanılır.',
          table: {
            headers: ['Soru', 'Amaç', 'Türkçesi'],
            rows: [
              ['Can I help you?', 'Yardım teklifi', 'Size yardım edebilir miyim?'],
              ['Can I see your passport?', 'İzin isteme', 'Pasaportunuzu görebilir miyim?'],
              ['Can you fasten your seatbelt?', 'Rica', 'Emniyet kemerinizi bağlar mısınız?'],
              ['Can you repeat that?', 'Rica', 'Tekrar eder misiniz?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Kabin İçi Diyaloglar',
          table: {
            headers: ['Kabin Memuru', 'Yolcu Cevabı'],
            rows: [
              ['Can I help you?', 'Yes, please. / No, thank you.'],
              ['Can I see your boarding pass?', 'Of course, here it is.'],
              ['Can you put your bag under the seat?', 'Sure, no problem.'],
              ['Can I get you something to drink?', 'Yes, water please.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Can I help you?" kabin ekibinin en çok kullandığı cümlelerden biridir!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ I help you with your luggage?',
          options: ['Can', 'Do', 'Are', 'Is'],
          correct: 'Can',
          explanation: 'Yardım teklifi için "Can I...?"'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ you fasten your seatbelt, please?',
          answer: 'Can',
          hint: 'Nazik rica'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'Can I help you?', right: 'Yes, please.' },
            { left: 'Can I see your passport?', right: 'Here it is.' },
            { left: 'Can you wait a moment?', right: 'Of course.' }
          ]
        }
      ]
    }
  },
  'A1-U4-L4': {
    id: 'A1-U4-L4',
    title: 'Could for Polite Requests',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Could - Nazik İstekler',
          explanation: '"Could" "can"\'den daha nazik ve resmidir. Profesyonel ortamlarda tercih edilir.',
          table: {
            headers: ['Can (İnformal)', 'Could (Nazik/Resmi)'],
            rows: [
              ['Can I help you?', 'Could I help you?'],
              ['Can you wait?', 'Could you wait?'],
              ['Can I see your ticket?', 'Could I see your ticket?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Profesyonel İstekler',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Kullanım'],
            rows: [
              ['Could you fasten your seatbelt?', 'Emniyet kemerinizi bağlar mısınız?', 'Rica'],
              ['Could I see your passport?', 'Pasaportunuzu görebilir miyim?', 'İzin'],
              ['Could you please wait here?', 'Lütfen burada bekler misiniz?', 'Nazik rica'],
              ['Could I assist you?', 'Size yardımcı olabilir miyim?', 'Teklif']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "Could" kullanmak daha profesyonel bir izlenim bırakır!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ I see your boarding pass, please?',
          options: ['Could', 'Can', 'Do', 'Would'],
          correct: 'Could',
          explanation: 'Nazik/resmi istek için "Could"'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ you please turn off your phone?',
          answer: 'Could',
          hint: 'Nazik rica'
        },
        {
          type: 'matching',
          instruction: 'İnformal ve resmi formları eşleştirin',
          pairs: [
            { left: 'Can I help?', right: 'Could I help?' },
            { left: 'Can you wait?', right: 'Could you wait?' },
            { left: 'Can I see?', right: 'Could I see?' }
          ]
        }
      ]
    }
  },
  'A1-U4-L5': {
    id: 'A1-U4-L5',
    title: 'Uygulama: Nazik İstekler',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Tam Diyalog',
          explanation: 'Kabin memuru ve yolcu arasında nazik bir konuşma:',
          table: {
            headers: ['Konuşmacı', 'Cümle'],
            rows: [
              ['Cabin Crew', 'Good morning! Could I see your boarding pass, please?'],
              ['Passenger', 'Of course, here it is.'],
              ['Cabin Crew', 'Thank you. Your seat is 15A. Could you follow me, please?'],
              ['Passenger', 'Can I put my bag here?'],
              ['Cabin Crew', 'Yes, you can. Could you please put your smaller bag under the seat?'],
              ['Passenger', 'Sure, no problem. Could I have a blanket?'],
              ['Cabin Crew', 'Of course! I\'ll bring one for you.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Please" eklemek cümleyi daha da nazik yapar: "Could you wait, please?"'
        },
        {
          type: 'vocabulary',
          title: '✈️ Nazik İfade Kelimeleri',
          words: [
            { en: 'please', tr: 'lütfen', pronunciation: '/pliːz/' },
            { en: 'of course', tr: 'elbette', pronunciation: '/əv kɔːs/' },
            { en: 'certainly', tr: 'kesinlikle', pronunciation: '/ˈsɜːtnli/' },
            { en: 'sure', tr: 'tabii', pronunciation: '/ʃʊər/' },
            { en: 'no problem', tr: 'sorun değil', pronunciation: '/nəʊ ˈprɒbləm/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ I assist you with anything else?',
          options: ['Could', 'Can', 'Do', 'Would'],
          correct: 'Could',
          explanation: 'Nazik teklif'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ you please follow me to your seat?',
          answer: 'Could',
          hint: 'Nazik istek'
        },
        {
          type: 'speaking',
          instruction: 'Şu durumlar için nazik cümleler kurun:',
          phrases: [
            'Ask to see boarding pass',
            'Ask passenger to sit down',
            'Offer help with luggage',
            'Ask passenger to fasten seatbelt'
          ]
        }
      ]
    }
  },
  'A1-U4-EXAM': {
    id: 'A1-U4-EXAM',
    title: 'Ünite 4 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'I _____ speak three languages.',
        options: ['can', 'cans', 'am can', 'could'],
        correct: 'can',
        explanation: 'Yetenek ifadesi'
      },
      {
        type: 'multipleChoice',
        question: "You _____ smoke on the aircraft.",
        options: ["can't", 'can', "could", "couldn't"],
        correct: "can't",
        explanation: 'Yasak - olumsuz'
      },
      {
        type: 'multipleChoice',
        question: '_____ I help you with your bags?',
        options: ['Can', 'Do', 'Are', 'Does'],
        correct: 'Can',
        explanation: 'Yardım teklifi'
      },
      {
        type: 'multipleChoice',
        question: '_____ you please fasten your seatbelt?',
        options: ['Could', 'Can', 'Do', 'Does'],
        correct: 'Could',
        explanation: 'Nazik istek'
      },
      {
        type: 'fillInBlank',
        sentence: 'She _____ handle difficult situations.',
        answer: 'can',
        hint: 'Yetenek'
      },
      {
        type: 'matchPairs',
        instruction: 'Formları eşleştirin',
        pairs: [
          { left: 'Can', right: 'İnformal istek' },
          { left: 'Could', right: 'Nazik/Resmi istek' },
          { left: "Can't", right: 'Yapamama/Yasak' }
        ]
      }
    ]
  }
};

export default A1_UNIT_4;
